
import React from 'react';

import PropTypes from 'prop-types';
import {
  Grid,
  Typography,
  Slide,
  Box,
  FormControl,
  InputLabel,
  OutlinedInput,
  Select,
  MenuItem
} from '@mui/material';
import StateSelect from './StateSelect';
import TitleSelect from './TitleSelect';

const formControlSx = {
  '& .MuiOutlinedInput-root': {
    color: '#333',
    '& fieldset': {
      borderColor: '#BDBDBD'
    },
    '&:hover fieldset': {
      borderColor: '#DDAC5D'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#DDAC5D',
      borderWidth: 1
    }
  },
  '& .MuiInputLabel-root': {
    color: '#9E9E9E'
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#DDAC5D'
  }
};

const StepOne = () => {
  const [title, setTitle] = React.useState('');
  return (
    <Slide in timeout={300} direction="up">
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: {
            xs: 'center', // down('md') and down('sm')
            md: 'flex-start'
          },
          flexDirection: 'column',
          transition: 'display 2s',
          width: '100%',
          maxWidth: '1200px',
          mx: 'auto'
        }}>
        <Typography variant="formSubTitle">
          Step 1 - Account Owner Information
        </Typography>

        <Grid
          container
          spacing={3}
          sx={{
            maxWidth: 1290,
            mx: 'auto'
          }}>
          <Grid size={{ xs: 12, md: 4 }}>
            <FormControl fullWidth variant="outlined" sx={formControlSx}>
              <InputLabel htmlFor="firstName">First Name *</InputLabel>

              <OutlinedInput
                size="lg"
                id="firstName"
                name="firstName"
                label="First Name *"
              />
            </FormControl>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <FormControl fullWidth variant="outlined" sx={formControlSx}>
              <InputLabel htmlFor="lastName">Last Name *</InputLabel>

              <OutlinedInput
                id="lastName"
                name="lastName"
                label="Last Name *"
              />
            </FormControl>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <TitleSelect
              sx={formControlSx}
              value={title}
              onChange={e => setTitle(e.target.value)}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl fullWidth variant="outlined" sx={formControlSx}>
              <InputLabel htmlFor="orgName">Organization Name</InputLabel>

              <OutlinedInput
                id="orgName"
                name="orgName"
                label="Organization Name"
              />
            </FormControl>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl fullWidth variant="outlined" sx={formControlSx}>
              <InputLabel htmlFor="orgWeb">Organization Website</InputLabel>

              <OutlinedInput
                id="orgWeb"
                name="orgWeb"
                label="Organization Website"
              />
            </FormControl>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl fullWidth variant="outlined" sx={formControlSx}>
              <InputLabel htmlFor="bphone">Business Phone</InputLabel>

              <OutlinedInput id="bphone" name="bphone" label="Business Phone" />
            </FormControl>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl fullWidth variant="outlined" sx={formControlSx}>
              <InputLabel htmlFor="bemail">Email Address</InputLabel>

              <OutlinedInput id="bemail" name="bemail" label="Email Address" />
            </FormControl>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl fullWidth variant="outlined" sx={formControlSx}>
              <InputLabel htmlFor="add">Address</InputLabel>

              <OutlinedInput id="add" name="add" label="Address" />
            </FormControl>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl fullWidth variant="outlined" sx={formControlSx}>
              <InputLabel htmlFor="city">City</InputLabel>

              <OutlinedInput id="city" name="city" label="City" />
            </FormControl>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <StateSelect sx={formControlSx} />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl fullWidth variant="outlined" sx={formControlSx}>
              <InputLabel htmlFor="zip">Zip</InputLabel>

              <OutlinedInput id="zip" name="zip" label="Zip" />
            </FormControl>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

StepOne.propTypes = {
  className: PropTypes.string
};

export default StepOne;
